import { useMemo } from "react"
import { useEnvironment } from "../../../../../modules/environment/envHooks"

/**
 * Resolves a potentially relative API image URL to an absolute URL.
 * Some API responses return paths like "/api/public/..." which must be
 * prefixed with the API origin (e.g. "https://test.facilitynet.dk").
 */
export function useApiImageUrl(imageUrl: string | undefined): string | undefined {
    const { currentEnv } = useEnvironment()

    return useMemo(() => {
        if (!imageUrl) return undefined

        // Already absolute (e.g. local dev where the API returns full URLs) — use as-is
        if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) return imageUrl

        // Relative path — prefix with API origin
        try {
            const { origin } = new URL(currentEnv.api.baseUrl)
            return `${origin}${imageUrl}`
        } catch {
            return imageUrl
        }
    }, [imageUrl, currentEnv.api.baseUrl])
}
